import DocumentsContainer from "../components/DocumentsContainer/DocumentsContainer";
import Card from "../components/Card/Card";
import styled from "styled-components";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { useEffect, useState } from "react";
import { getDocuments } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { SET_LOADING } from "../redux/action-types";
import Header from "../components/Header";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .formContainer {
    max-width: 800px;
    width: 100%;
    margin-top: 3%;
  }

  .buttonContainer {
    width: 100%;
    max-width: 800px;
    text-align: right;
    margin-top: 15px;
  }
`;

const Documents = () => {
  const dispatch = useDispatch();
  const { loading, documents, userAccountDetails } = useSelector(
    (state) => state.user
  );
  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    dispatch(getDocuments());
  }, [dispatch]);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  useEffect(() => {
    if (documents && userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    } else {
      dispatch({ type: SET_LOADING, payload: true });
    }
  }, [dispatch, documents, userAccountDetails]);

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Header />
      <BodyWrapper>
        <div className="formContainer">
          {documents ? (
            <Card>{<DocumentsContainer documentsList={documents} />}</Card>
          ) : (
            <></>
          )}
        </div>
      </BodyWrapper>
    </>
  );
};

export default Documents;
